import {
  FieldsToFilterInterface,
  UserGlobalFilter,
} from "../../models/UserModel/UserGlobalFilter";
import client from "../client";

class UserGlobalFilterService {
  async GetAll(userId: string) {
    try {
      let url = `/api/UserGlobalFilter/GetAll`;
      const { data } = await client.post<UserGlobalFilter[]>(url, { userId });
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async GetFieldsToFilter() {
    try {
      let url = `/api/UserGlobalFilter/GetFieldsToFilter`;
      const { data } = await client.post<FieldsToFilterInterface>(url, {
        url: "",
      });
      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async RemoveGlobalFilter(id: string) {
    try {
      let url = `/api/UserGlobalFilter/remove/${id}`;
      const { data } = await client.post(url, { url: "" });

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async AddGlobalFilter(form: UserGlobalFilter) {
    try {
      const { id, ...formData } = form;
      let url = `/api/UserGlobalFilter/Create`;
      const { data } = await client.post(url, formData);

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
  async Update(form: UserGlobalFilter) {
    try {
      const { id, ...formData } = form;
      let url = `/api/UserGlobalFilter/update/${id}`;
      const { data } = await client.post(url, formData);

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
}

export default new UserGlobalFilterService();
